module.exports = __webpack_public_path__ + "static/media/image_1.d031d899.svg";